import React from 'react';

const Messages = ({msg,profile,name}) => {

    if(msg.direction === "incoming"){
    return (    
        <>
        <div className="d-flex justify-content-between">
            <p className="small mb-1"><strong>{msg.sender}</strong></p>
        </div>
        <div className="d-flex flex-row justify-content-start mb-4">
            <img
            src="https://static.vecteezy.com/system/resources/previews/024/558/806/non_2x/openai-chatgpt-logo-icon-free-png.png"
            alt="avatar 1"
            className="shadow-none rounded-circle"
            style={{ width: "45px", height: "45px" }}
            />
            <div
            className="p-3 ms-3"
            style={{
                borderRadius: "15px",
                backgroundColor: "rgba(57, 192, 237,.2)",
            }}
            >
            <p className="small mb-0"> {msg.message}</p>
            </div>
        </div> 
        </>
    );
    }else{
    return (    
        <>
        <div className="d-flex justify-content-between">
           <p className="small mb-1 text-muted"></p>
           <p className="small mb-1"><strong>{name}</strong></p>
        </div>
        <div className="d-flex flex-row justify-content-end mb-4">
            <div
            className="p-3 me-3 border"
            style={{ borderRadius: "15px", backgroundColor: "#fbfbfb" }}
            >
            <p className="small mb-0">
            {msg.message}
            </p>
            </div>
            <img
            className="shadow-none rounded-circle"
            src={profile}
            alt="avatar 1"
            style={{ width: "45px", height: "45px" }}
            />
        </div>
        </>
    );
    }
   
  
};

export default Messages;